export const ROUTES = () => [
  {
    label: 'special_billing.amend-billing-agreement',
    link: '',
  },
  {
    label: 'special-billing-agreements',
    link: 'additional-functionalities/special-billing',
  },
  {
    label: 'additional_functionalities',
    link: 'additional-functionalities',
  },
];
